import "./DesktopMonetizeOverview.css";
import { useLang } from "../../../../i18n/LangContext";
import overviewImage from "../../../../assets/desktopMonetize/overview/offerwall.png";

export default function DesktopMonetizeOverview({
  id = "overview",
  imageSrc = overviewImage,
  onGetStarted = () => {},
  onContact = () => {},
}) {
  const { t } = useLang();
  const data = t?.monetizeOverview;
  if (!data) return null;

  return (
    <section id={id} className="mon-overview-root" aria-label="Monetize overview">
      <div className="mon-overview-wrap">
        <div className="mon-overview-left">
          <p className="mon-overview-eyebrow">{data.eyebrow}</p>
          <h2 className="mon-overview-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
          <p className="mon-overview-desc">{data.desc}</p>

          <div className="mon-overview-cta">
            <button className="mon-overview-btn" onClick={onGetStarted}>
              <span>{data.ctaGetStarted.toUpperCase()}</span>
            </button>
            <button className="mon-overview-btn" onClick={onContact}>
              <span>{data.ctaContact.toUpperCase()}</span>
            </button>
          </div>
        </div>

        <div className="mon-overview-right">
          <img src={imageSrc} alt={data.imageAlt} loading="lazy" />
        </div>
      </div>
    </section>
  );
}
